import React, { useMemo } from "react";

import { Alert } from "ra-friendsofbabba";
import { Collapse } from "@material-ui/core";
import TextContentInput from "../../component/input/TextContentInput";
import { get } from "lodash";
import { useFormState } from "react-final-form";
import { useTranslate } from "ra-core";

const OtherInstitutionsInput = (props) => {
  const formState = useFormState();
  const translate = useTranslate();
  const hasOtherInstitutions = useMemo(
    () => get(formState.values, "has_other_institutions", false),
    [formState.values]
  );

  return (
    <Collapse in={hasOtherInstitutions}>
      <Alert severity="info">
        <div
          dangerouslySetInnerHTML={{
            __html: translate(
              `resources.projects.fields.has_other_institutions.warn`
            ),
          }}
        />
      </Alert>
      <TextContentInput {...props} multiline maxLength={1000} />
    </Collapse>
  );
};
export default OtherInstitutionsInput;
